export default __webpack_public_path__ + "659d204517db69bdf07719f4755e5faf.png";